
import Vue from 'vue'
import { Prop, Component, Watch } from 'vue-property-decorator'
import { DateTime, Duration } from 'luxon'

@Component
export default class Timer extends Vue {
  @Prop({ type: String, required: true })
  readonly expires!: string

  hasExpired = false
  intervalId: number | null = null
  timeRemaining = this.getTimeRemaining()

  get formattedTimeRemaining() {
    const days = this.timeRemaining.as('days')
    const hours = this.timeRemaining.as('hours')
    const minutes = this.timeRemaining.as('minutes')

    let format = `dd'd' hh'h' mm'm'`
    if (!days && !hours && minutes < 5) {
      format += ` ss's'`
    }

    return this.timeRemaining.toFormat(format)
  }

  get color() {
    if (this.hasExpired) {
      return {
        foreground: '#FFFFFF',
        background: '#B5B5B5'
      }
    } else {
      return {
        foreground: '#E58E4C',
        background: '#FBE1CB'
      }
    }
  }

  @Watch('expires')
  private expiresChanged(value: Date) {
    if (value && this.hasExpired) {
      this.poll()
    }
  }

  mounted() {
    if (this.timeRemaining.milliseconds > 0) {
      this.poll()
    } else {
      this.hasExpired = true
    }
  }

  beforeDestroy() {
    this.clearPoll()
  }

  poll() {
    this.hasExpired = false
    if (this.intervalId) {
      return
    }
    this.intervalId = window.setInterval(() => {
      this.timeRemaining = this.getTimeRemaining()
      if (this.timeRemaining.milliseconds === 0) {
        this.hasExpired = true
        this.clearPoll()
        this.$emit('expired')
      }
    }, 1000)
  }

  clearPoll() {
    if (this.intervalId !== null) {
      window.clearInterval(this.intervalId)
    }
    this.intervalId = null
  }

  getTimeRemaining() {
    const target = DateTime.fromJSDate(new Date(this.expires))
    const difference = target.diffNow()
    return difference.milliseconds > 0 ? difference : Duration.fromMillis(0)
  }
}
